import React, { useCallback, useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-datepicker";
import {
  changeSettingValue,
  changeTaxEndApi,
  checkTaxYear,
  deleteAccDocument,
  getFinanceGeneralSettings,
  getState,
  getTaxYearEndDate,
  saveAccountingPeriod,
  saveFinanceGeneralSettings,
  showNotificationWithTimeout,
  toggleSettingAccModal,
  toggleSettingDocModal,
  updatePostingPeriodStatus,
  uploadAccDocument,
  uploadAccLogo,
} from "../../../../../Redux/actions";
import ErrorContainer from "../../../../Components/ErrorContainer";
import {
  capitalizeFirstLetter,
  changeDateFormat,
  checkNull,
  downloadFileFromUrl,
  getFileNameFromUrl,
  isChildAccount,
  isFutureFromToday,
  isPastFromToday,
  parseStringToDate,
} from "../../../../../helpers";
import TimePicker from "react-times";
import LoadingBtn from "../../../../Components/LoadingBtn";

import moment from "moment";
import ModelContainer from "../../../../Components/ModelContainer";
import ConfirmModel from "../../../../Components/ConfirmModel";
const settingSchema = yup
  .object({
    account_name: yup.string().required(),
    sales_tax_rate: yup.string().required(),
    telephone: yup.string().nullable(),
    fax: yup.string().nullable(),
    address: yup.string().required(),
    address_2: yup.string().nullable(),
    country_id: yup.string().required(),
    state_id: yup.string().required(),
    city_id: yup.string().required(),
    zip_code: yup.string().nullable(),
    auto_approval_threshold: yup.string().nullable(),
    non_trade_payments: yup.string().nullable(),
    auto_create_payments: yup.string().nullable(),
    purchase_requisition_auto_approval: yup.string().nullable(),
    trade_order_auto_approval: yup.string().nullable(),
    default_posting_period_status: yup.string().required(),
    daily_sales_email_preference: yup.string().required(),
  })
  .required();

const accSchema = yup
  .object({
    is_first_period: yup.number().required(),
    ap_id: yup.string(),
    tax_year: yup.string().required(),
    account_period_setting_id: yup.string().required(),
    sub_period: yup.string().required(),
    day_of_week: yup.string().when("account_period_setting_id", {
      is: (period_setting) => period_setting != 4,
      then: yup.string().required(),
    }),
    start_date: yup.string().required(),
    end_date: yup.string().required(),
  })
  .required();
const Settings = (params) => {
  const [ref1, inView1, entry1] = useInView({ threshold: 0.5 });
  const [ref2, inView2, entry2] = useInView({ threshold: 0.5 });
  const [ref3, inView3, entry3] = useInView({ threshold: 0.5 });

  function scrollToDiv(divId) {
    // const targetParent = document.querySelector(".settings-right-content");
    // const targetParentTop = targetParent.getClientRects()[0].top;

    const targetDiv = document.getElementById(divId);
    // const targetDivTop = targetDiv.getClientRects()[0].top;

    // const difference = targetDivTop - targetParentTop + targetParent.scrollTop;
    // targetParent.scroll({ left: 0, top: difference, behavior: "smooth" });

    // OR we can do it by using scrollIntoView()
    targetDiv.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFinanceGeneralSettings());

    return () => {
      dispatch(changeSettingValue("finance_general_details", null));
    };
  }, []);

  const user_details = useSelector((state) => state.authReducer.user_details);
  const {
    finance_general_details,
    is_save_general_details_loading,
    accountingModal,
    is_modal_loading,
    documentModal,
  } = useSelector((state) => state.settingReducer);
  const { states: apiStates } = useSelector((state) => state.authReducer);

  /* Account tax years */
  const initialAccForm = {
    is_first_period: 1,
    ap_id: "",
    tax_year: "",
    account_period_setting_id: "",
    sub_period: "",
    day_of_week: "",
    start_date: "",
    end_date: "",
  };
  const {
    register,
    formState: { errors: accErrors },
    handleSubmit: accountingSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(accSchema),
    defaultValues: initialAccForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const {
    tax_year_res,
    tax_end_date_res,
    tax_end_date_start_from,
    run_tax_end_date_api: taxEndApi,
  } = useSelector((state) => state.authReducer);

  const [accInputForm, setAccInputForm] = useState(initialAccForm);
  const [selectedDocFile, setSelectedDocFile] = useState(null);
  const [accPeriodId, setAccPeriodId] = useState(null);
  const accPeriodIdRef = useRef(accPeriodId);
  accPeriodIdRef.current = accPeriodId;

  const [accDocumentId, setAccDocumentId] = useState(null);
  const accDocumentIdRef = useRef(accDocumentId);
  accDocumentIdRef.current = accDocumentId;
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);

  const onChangeOfTaxYear = () => {
    if (accInputForm?.is_first_period == 0) {
      dispatch(
        checkTaxYear({
          tax_year: accInputForm?.tax_year,
        })
      );
    } else {
      dispatch(
        changeTaxEndApi({
          run_tax_end_date_api: taxEndApi == null ? true : !taxEndApi,
        })
      );
    }
  };
  const changeAccInputHandler = (input, val) => {
    setValue(input, val);
    setAccInputForm((prevState) => ({ ...prevState, [input]: val }));
    if (
      (input == "start_date" && val !== "") ||
      (input != "start_date" &&
        accInputForm?.start_date !== "" &&
        (input == "tax_year" || input == "sub_period"))
    ) {
      onChangeOfTaxYear();
    }
  };

  useEffect(() => {
    if (taxEndApi !== null)
      dispatch(
        getTaxYearEndDate({
          ...accInputForm,
          start_date:
            accInputForm?.start_date && accInputForm?.start_date !== ""
              ? moment(accInputForm?.start_date).format("yyyy-MM-DD")
              : "",
          end_date:
            accInputForm?.end_date && accInputForm?.end_date !== ""
              ? moment(accInputForm?.end_date).format("yyyy-MM-DD")
              : "",
        })
      );
  }, [taxEndApi]);

  useEffect(() => {
    if (tax_end_date_res?.return == 1 && tax_end_date_res?.data) {
      if (tax_end_date_start_from) {
        changeAccInputHandler(
          "end_date",
          moment(tax_end_date_res?.data).toDate()
        );
      } else {
        changeAccInputHandler(
          "start_date",
          moment(tax_end_date_res?.data).toDate()
        );
      }
    } else if (tax_end_date_res?.return == 0) {
      changeAccInputHandler("end_date", "");
      changeAccInputHandler("start_date", "");
      if (tax_end_date_res?.message) {
        dispatch(
          showNotificationWithTimeout(`${tax_end_date_res?.message}`, "error")
        );
      }
    }
  }, [tax_end_date_res]);

  const closeAccModal = useCallback(
    (value) => {
      dispatch(toggleSettingAccModal(value));
      initialModalState();
    },
    [accountingModal]
  );

  const onDocumentFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      setSelectedDocFile(event.target.files[0]);
      event.target.value = null;
    }
  };

  const submitDocument = () => {
    console.log("selectedDocFile", selectedDocFile);
    if (selectedDocFile !== null) {
      const formData = new FormData();
      formData.append("document_url", selectedDocFile, selectedDocFile?.name);
      dispatch(
        uploadAccDocument(formData, accPeriodIdRef.current, null, "finance")
      );
      // closeDocumentModal(false);
    }
  };

  const submitAccountingForm = (data) => {
    data.start_date = moment(data?.start_date).format("yyyy-MM-DD");
    data.end_date = moment(data?.end_date).format("yyyy-MM-DD");
    data.add_to_child = 1;
    console.log("submitAccountingForm", data);
    dispatch(saveAccountingPeriod(data, null, "finance"));
    // closeModal(false);
  };

  const editAccountingHandler = (period) => {
    closeAccModal(true);
    const editValues = {
      is_first_period: accInputForm?.is_first_period,
      ap_id: period?.id ?? "",
      tax_year: period?.tax_year ?? "",
      account_period_setting_id: period?.account_period_setting_id ?? "",
      sub_period: period?.sub_period ?? "",
      day_of_week: period?.day_of_week ?? "",
      start_date: period?.start_date ? moment(period?.start_date).toDate() : "",
      end_date: period?.end_date ? moment(period?.end_date).toDate() : "",
    };
    setAccInputForm(editValues);
    reset(editValues);
  };

  const initialModalState = () => {
    setAccInputForm(initialAccForm);
    reset(initialAccForm);
    changeTaxEndApi({
      run_tax_end_date_api: null,
      tax_end_date_res: null,
    });
  };

  const closeDocumentModal = useCallback(
    (value) => {
      dispatch(toggleSettingDocModal(value));
      setSelectedDocFile(null);
    },
    [documentModal]
  );
  const closeDeleteDocumentModal = useCallback(
    (value) => {
      setDeleteDocumentModal(value);
      if (!value) setAccPeriodId(null);
    },
    [documentModal]
  );

  const submitDeleteDocumentHandler = () => {
    dispatch(
      deleteAccDocument({ id: accDocumentIdRef.current }, null, "finance")
    );
    closeDeleteDocumentModal(false);
  };

  /* Posting period */
  const [accPostingPeriodId, setAccPostingPeriodId] = useState(null);
  const [accPeriodStatusId, setAccPeriodStatusId] = useState(null);
  const [accPostingPeriodModal, setAccPostingPeriodModal] = useState(false);
  const closeAccPostingPeriodModal = useCallback(
    (value) => {
      setAccPostingPeriodModal(value);
      if (!value) {
        setAccPostingPeriodId(null);
        setAccPeriodStatusId(null);
      }
    },
    [accPostingPeriodModal]
  );
  const submitAccPostingPeriodHandler = () => {
    dispatch(
      updatePostingPeriodStatus(
        { id: accPostingPeriodId, status_id: accPeriodStatusId },
        null,
        "finance"
      )
    );
    closeAccPostingPeriodModal(false);
  };

  const getAccPeriodStatusBtn = (period) => {
    let res = null;
    if (
      checkNull(period?.period_end, false) &&
      checkNull(period?.period_start, false) &&
      isPastFromToday(period?.period_start, true) &&
      isFutureFromToday(period?.period_end, true)
    ) {
      res = (
        <button class="btn cancel" type="button">
          In Progress
        </button>
      );
    } else if (period?.status_id == 56) {
      res = (
        <button
          className={`btn bordered-btn mr0${
            isChildAccount(user_details) ? "" : " update_status"
          }`}
          val="59"
          val_id={period?.id}
          type="button"
          onClick={() => {
            setAccPostingPeriodId(period?.id);
            setAccPeriodStatusId("59");
            closeAccPostingPeriodModal(true);
          }}
        >
          Close Period
        </button>
      );
    } else if (period?.status_id == 58) {
      res = (
        <button
          className={`btn bordered cancel${
            isChildAccount(user_details) ? "" : " update_status"
          }`}
          val="56"
          val_id={period?.id}
          type="button"
          onClick={() => {
            setAccPostingPeriodId(period?.id);
            setAccPeriodStatusId("56");
            closeAccPostingPeriodModal(true);
          }}
        >
          Open Period
        </button>
      );
    } else if (period?.status_id == 59) {
      res = (
        <button
          className={`btn bordered-btn cancel${
            isChildAccount(user_details) ? "" : " update_status"
          }`}
          val="56"
          val_id={period?.id}
          type="button"
          onClick={() => {
            setAccPostingPeriodId(period?.id);
            setAccPeriodStatusId("56");
            closeAccPostingPeriodModal(true);
          }}
        >
          Reopen Period
        </button>
      );
    }
    return res;
  };

  /* general setting form */
  const settingFormBtn = useRef(null);
  const [settingInputForm, setSettingInputForm] = useState(initialSettingForm);
  const [stateArr, setStateArr] = useState(null);
  const initialSettingForm = {
    account_name: "",
    sales_tax_rate: "",
    telephone: "",
    fax: "",
    address: "",
    address_2: "",
    country_id: "",
    state_id: "",
    city_id: "",
    zip_code: "",
    auto_approval_threshold: "",
    non_trade_payments: "",
    auto_create_payments: "",
    purchase_requisition_auto_approval: "",
    trade_order_auto_approval: "",
    default_posting_period_status: "",
    daily_sales_email_preference: "",
  };

  useEffect(() => {
    if (finance_general_details?.merchant_data) {
      let newSettingInput = { ...settingInputForm };
      newSettingInput.account_name =
        finance_general_details?.merchant_data?.account_name ?? "";
      newSettingInput.sales_tax_rate =
        finance_general_details?.merchant_data?.sales_tax_rate ?? "";
      newSettingInput.telephone =
        finance_general_details?.merchant_data?.telephone ?? "";
      newSettingInput.fax = finance_general_details?.merchant_data?.fax ?? "";
      newSettingInput.address =
        finance_general_details?.merchant_data?.address ?? "";
      newSettingInput.address_2 =
        finance_general_details?.merchant_data?.address_2 ?? "";
      newSettingInput.country_id =
        finance_general_details?.merchant_data?.country_id ?? "";
      newSettingInput.state_id =
        finance_general_details?.merchant_data?.state_id ?? "";
      newSettingInput.city_id =
        finance_general_details?.merchant_data?.city_id ?? "";
      newSettingInput.auto_approval_threshold =
        finance_general_details?.merchant_data?.auto_approval_threshold ?? "";
      newSettingInput.non_trade_payments =
        finance_general_details?.merchant_data?.non_trade_payments ?? "";
      newSettingInput.auto_create_payments =
        finance_general_details?.merchant_data?.auto_create_payments ?? "";
      newSettingInput.purchase_requisition_auto_approval =
        finance_general_details?.merchant_data
          ?.purchase_requisition_auto_approval ?? "";
      newSettingInput.trade_order_auto_approval =
        finance_general_details?.merchant_data?.trade_order_auto_approval ?? "";
      newSettingInput.default_posting_period_status =
        finance_general_details?.merchant_data?.default_posting_period_status ??
        "";
      newSettingInput.daily_sales_email_preference =
        finance_general_details?.merchant_data?.daily_sales_email_preference ??
        "";
      resetSettingHandler(newSettingInput);
    }
    setStateArr(finance_general_details?.state ?? null);
  }, [finance_general_details]);

  const changeSettingInputHandler = (input, val, getStateApi = true) => {
    console.log("checkvalue", input, val);
    settingSetValue(input, val);
    setSettingInputForm((prevState) => ({ ...prevState, [input]: val }));
    if (getStateApi && input == "country_id") {
      const stateQuery = checkNull(val, false) ? `?country_id=${val}` : "";
      dispatch(getState(stateQuery));
      changeSettingInputHandler("state_id", "");
    }
  };

  useEffect(() => {
    if (apiStates && apiStates !== null) {
      setStateArr(apiStates);
    }
  }, [apiStates]);

  const {
    register: settingReg,
    formState: { errors: settingErrors },
    handleSubmit: settingSubmit,
    control: settingControl,
    setValue: settingSetValue,
    reset: settingReset,
  } = useForm({
    resolver: yupResolver(settingSchema),
    defaultValues: initialSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const submitSettingHandler = (data) => {
    data.id = finance_general_details?.merchant_data?.id ?? "";
    let scheduleDayArr = [];
    Object.keys(scheduleDayForm)
      .filter((p) => {
        return scheduleDayForm[p].is_checked == true;
      })
      .map((input) => {
        const inputObj = {
          weekday: input,
          start_time: parseStringToDate(
            scheduleDayForm[input].start_time,
            "hh:mm A",
            "HH:mm:ss"
          ),
          end_time: parseStringToDate(
            scheduleDayForm[input].end_time,
            "hh:mm A",
            "HH:mm:ss"
          ),
        };
        if (scheduleDayForm[input].id !== "") {
          inputObj.id = scheduleDayForm[input].id;
        }
        scheduleDayArr.push(inputObj);
      });
    data.scheduled_days = scheduleDayArr;
    console.log("submitSettingHandler", data);
    dispatch(saveFinanceGeneralSettings(data));
  };
  const resetSettingHandler = (resetVal = initialSettingForm) => {
    setSettingInputForm(resetVal);
    settingReset(resetVal);
  };

  const initialDayTime = {
    id: "",
    start_time: "05:00 AM",
    end_time: "04:59 AM",
    is_checked: true,
  };

  const initialScheduleDayForm = {
    monday: initialDayTime,
    tuesday: initialDayTime,
    wednesday: initialDayTime,
    thursday: initialDayTime,
    friday: initialDayTime,
    saturday: initialDayTime,
    sunday: initialDayTime,
  };

  const [scheduleDayForm, setScheduleDayForm] = useState(
    initialScheduleDayForm
  );
  const changeScheduleDayHandler = (input, type, val) => {
    const prevValue = { ...scheduleDayForm[input], [type]: val };
    setScheduleDayForm((prevState) => ({ ...prevState, [input]: prevValue }));
  };

  useEffect(() => {
    if (
      finance_general_details?.scheduledDays &&
      finance_general_details?.scheduledDays.length > 0
    ) {
      const newScheduleDayObj = { ...initialScheduleDayForm };
      Object.keys(newScheduleDayObj).map((input) => {
        const index = finance_general_details?.scheduledDays.findIndex(
          (p) => p.weekday == input
        );
        if (index > -1) {
          const scheduledDay = finance_general_details?.scheduledDays[index];
          newScheduleDayObj[input] = {
            id: scheduledDay?.id,
            start_time: parseStringToDate(
              scheduledDay?.start_time,
              "HH:mm:ss",
              "hh:mm A"
            ),
            end_time: parseStringToDate(
              scheduledDay?.end_time,
              "HH:mm:ss",
              "hh:mm A"
            ),
            is_checked: true,
          };
        } else {
          newScheduleDayObj[input] = {
            id: "",
            start_time: "05:00 AM",
            end_time: "04:59 AM",
            is_checked: false,
          };
        }
      });
      console.log("newScheduleDayObj", newScheduleDayObj);
      setScheduleDayForm(newScheduleDayObj);
    }
  }, [finance_general_details?.scheduledDays]);

  return (
    <div
      className="tab-pane fade show active"
      id="nav-home"
      role="tabpanel"
      aria-labelledby="nav-home-tab"
    >
      <div className="row">
        <form onSubmit={settingSubmit(submitSettingHandler)}>
          <div className="container px-0">
            <div className="row accountSettingSec mt-2 mt-md-4">
              <div className="col-xl-8 col-12">
                <div className="shadowclass mt-0 scrolling">
                  <h4 className="event-alert">
                    Account Settings
                    <span className="green_tag active-tag"> Active </span>
                  </h4>
                  <div className="d-flex scroll-parent">
                    <div className="settings-left-content fixed-pos">
                      <ul className="settingMenus">
                        <li
                          onClick={() => scrollToDiv("AccDetail_dayTime_div")}
                          id="AccDetail_li"
                          className={`${inView1 ? "active" : " "}`}
                        >
                          <a id="AccDetail_dayTime_a">
                            Account <br />
                            Details
                          </a>
                        </li>
                        <li
                          onClick={() => scrollToDiv("Address_dayTime_div")}
                          id="Address_li"
                          className={`${inView2 ? "active" : " "}`}
                        >
                          <a id="Address_dayTime_a">Address</a>
                        </li>
                        <li
                          onClick={() => scrollToDiv("FinSettings_dayTime_div")}
                          id="FinSettings_li"
                          className={`${inView3 ? "active" : " "}`}
                        >
                          <a id="FinSettings_dayTime_a">
                            Finance <br />
                            Settings
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="settings-right-content">
                      <div className="date-sec-scroll">
                            <div
                              ref={ref1}
                              id="AccDetail_dayTime_div"
                              className="row-fluid scroll-change full_div"
                              day_time="AccDetail"
                            >
                              <div className="form-secs">
                                <h4> Account Details </h4>

                                <ul className="ingredient-info edit-shift">
                                  <li>
                                    <label className="required">
                                      Account Name
                                    </label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("account_name")}
                                        className="valid"
                                        required="required"
                                        maxlength="255"
                                        type="text"
                                        id="MerchantAccountName"
                                        value={settingInputForm?.account_name}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "account_name",
                                            e?.target?.value
                                          )
                                        }
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="account_name"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">
                                      Company Tax ID
                                    </label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        name="data[MerchantFinanceInfo][company_tax_id]"
                                        className="valid"
                                        required="required"
                                        type="text"
                                        value={
                                          finance_general_details?.merchant_data
                                            ?.company_tax_id
                                        }
                                        disabled="disabled"
                                        id="MerchantFinanceInfoCompanyTaxId"
                                      />{" "}
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">
                                      Account Currency
                                    </label>
                                    <div className="input-group select-div">
                                      <select
                                        name="data[MerchantFinanceInfo][currency_id]"
                                        className="valid"
                                        required="required"
                                        disabled="disabled"
                                        value={
                                          finance_general_details?.merchant_data
                                            ?.currency_id
                                        }
                                        id="MerchantFinanceInfoCurrencyId"
                                      >
                                        <option value="">Select</option>
                                        {checkNull(
                                          finance_general_details?.currency,
                                          false
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.currency
                                          ).map((currency) => {
                                            return (
                                              <option value={currency}>
                                                {finance_general_details
                                                  ?.currency?.[currency] ?? ""}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">
                                      Sales Tax Rate
                                    </label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("sales_tax_rate")}
                                        name="data[MerchantFinanceInfo][sales_tax_rate]"
                                        className="valid percent_format"
                                        required="required"
                                        type="text"
                                        value={settingInputForm?.sales_tax_rate}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "sales_tax_rate",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantFinanceInfoSalesTaxRate"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="sales_tax_rate"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">
                                      Company Name
                                    </label>
                                    <div className="input-group select-div">
                                      <select
                                        name="data[MerchantFinanceInfo][merchant_balance_sheet_id]"
                                        className="valid"
                                        value={
                                          finance_general_details?.merchant_data
                                            ?.merchant_balance_sheet_id
                                        }
                                        disabled="disabled"
                                        id="MerchantFinanceInfoMerchantBalanceSheetId"
                                      >
                                        <option value="">
                                          Select Balance Sheet
                                        </option>
                                        {checkNull(
                                          finance_general_details?.balancesheet,
                                          false
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.balancesheet
                                          ).map((sheet) => {
                                            return (
                                              <option value={sheet}>
                                                {finance_general_details
                                                  ?.balancesheet?.[sheet]
                                                  ?.balance_sheet_name ?? ""}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">
                                      Incorporation Date
                                    </label>
                                    <div className="span7 input-group  bootstrap-timepicker date-input date">
                                      
                                      <input
                                        name="data[MerchantFinanceInfo][incorporation_date]"
                                        className="valid input-datepicker-otherincome"
                                        required="required"
                                        type="text"
                                        disabled="disabled"
                                        value={
                                          checkNull(
                                            finance_general_details
                                              ?.merchant_data
                                              ?.incorporation_date,
                                            false
                                          )
                                            ? changeDateFormat(
                                                finance_general_details
                                                  ?.merchant_data
                                                  ?.incorporation_date
                                              )
                                            : ""
                                        }
                                        id="MerchantFinanceInfoIncorporationDate"
                                      />{" "}
                                    </div>
                                  </li>

                                  <li>
                                    <label className="">Telephone</label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("telephone")}
                                        name="data[Merchant][telephone]"
                                        className="valid"
                                        onkeypress="if(this.value.length==15) return false;"
                                        pattern="[0-9]{6,15}"
                                        type="text"
                                        value={settingInputForm?.telephone}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "telephone",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantTelephone"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="telephone"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="">Fax</label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("fax")}
                                        name="data[Merchant][fax]"
                                        className="valid"
                                        onkeypress="if(this.value.length==15) return false;"
                                        pattern="[0-9]{6,15}"
                                        maxlength="50"
                                        type="text"
                                        value={settingInputForm?.fax}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "fax",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantFax"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="fax"
                                      />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              id="Address_dayTime_div"
                              ref={ref2}
                              className="row-fluid scroll-change full_div"
                              day_time="Address"
                            >
                              <div className="form-secs">
                                <h4> Address </h4>
                                <ul className="ingredient-info edit-shift">
                                  <li>
                                    <label className="required">
                                      Address Line #1
                                    </label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("address")}
                                        name="data[Merchant][address]"
                                        className="valid"
                                        required="required"
                                        maxlength="200"
                                        type="text"
                                        value={settingInputForm?.address}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "address",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantAddress"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="address"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="">Address Line #2</label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("address_2")}
                                        name="data[Merchant][address_2]"
                                        className="valid"
                                        maxlength="200"
                                        type="text"
                                        value={settingInputForm?.address_2}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "address_2",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantAddress2"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="address_2"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">Country</label>
                                    <div className="input-group select-div">
                                      <select
                                        {...settingReg("country_id")}
                                        name="data[Merchant][country_id]"
                                        id="merchant_country_id"
                                        className="valid"
                                        required="required"
                                        value={settingInputForm?.country_id}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "country_id",
                                            e?.target?.value
                                          )
                                        }
                                      >
                                        <option value="">Select country</option>
                                        {checkNull(
                                          finance_general_details?.country,
                                          false
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.country
                                          ).map((index) => {
                                            return (
                                              <option value={index} key={index}>
                                                {
                                                  finance_general_details
                                                    ?.country?.[index]
                                                }{" "}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="country_id"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">State</label>
                                    <div
                                      className="input-group select-div"
                                      id="state_div"
                                    >
                                      <select
                                        {...settingReg("state_id")}
                                        name="data[Merchant][state_id]"
                                        id="merchant_state_id"
                                        className="valid"
                                        required="required"
                                        value={settingInputForm?.state_id}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "state_id",
                                            e?.target?.value
                                          )
                                        }
                                      >
                                        <option value="">Select state</option>
                                        {stateArr !== null &&
                                          Object.keys(stateArr).map((index) => {
                                            return (
                                              <option value={index} key={index}>
                                                {" "}
                                                {stateArr?.[index]}{" "}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="state_id"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">City</label>
                                    <div
                                      className="input-group d-flex align-items-center pt-0"
                                      id="city_div"
                                    >
                                      <input
                                        {...settingReg("city_id")}
                                        name="data[Merchant][city_id]"
                                        className="valid"
                                        required="required"
                                        type="text"
                                        value={settingInputForm?.city_id}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "city_id",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantCityId"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="city_id"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="required">Zip Code</label>
                                    <div className="input-group d-flex align-items-center pt-0">
                                      <input
                                        {...settingReg("zip_code")}
                                        name="data[Merchant][zip_code]"
                                        className="valid"
                                        maxlength="30"
                                        type="text"
                                        value={settingInputForm?.zip_code}
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "zip_code",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantZipCode"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="zip_code"
                                      />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              id="FinSettings_dayTime_div"
                              ref={ref3}
                              className="row-fluid scroll-change full_div"
                              day_time="FinSettings"
                            >
                              <div className="form-secs">
                                <h4> Finance Settings </h4>
                                <ul className="ingredient-info edit-shift">
                                  <li>
                                    <label className="">
                                      Payment Auto-Approval Threshold
                                    </label>
                                    <div className="input-group d-flex align-items-center pt-0 align-items-center pt-0">
                                      <span className="dolor-sign">$</span>
                                      <input
                                        {...settingReg(
                                          "auto_approval_threshold"
                                        )}
                                        name="data[Merchant][auto_approval_threshold]"
                                        className="valid number"
                                        placeholder="Set Approval Threshold"
                                        maxlength="50"
                                        type="text"
                                        value={
                                          settingInputForm?.auto_approval_threshold
                                        }
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "auto_approval_threshold",
                                            e?.target?.value
                                          )
                                        }
                                        id="MerchantAutoApprovalThreshold"
                                      />{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="auto_approval_threshold"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="">
                                      Non-Trade Payments Require Linked
                                      Invoice(s)?
                                    </label>
                                    <div className="input-group select-div">
                                      <select
                                        name="data[Merchant][non_trade_payments]"
                                        className="valid"
                                        id="MerchantNonTradePayments"
                                        {...settingReg("non_trade_payments")}
                                        value={
                                          settingInputForm?.non_trade_payments
                                        }
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "non_trade_payments",
                                            e?.target?.value
                                          )
                                        }
                                      >
                                        <option value="">Select</option>
                                        {checkNull(
                                          finance_general_details?.yesnoOptions
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.yesnoOptions
                                          ).map((index) => {
                                            return (
                                              <option value={index} key={index}>
                                                {" "}
                                                {
                                                  finance_general_details
                                                    ?.yesnoOptions?.[index]
                                                }{" "}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="non_trade_payments"
                                      />
                                    </div>
                                  </li>
                                  <li>
                                    <label className="">
                                      Auto-Create Payment(s) for Approved
                                      Invoices
                                    </label>
                                    <div className="input-group select-div">
                                      <select
                                        {...settingReg("auto_create_payments")}
                                        value={
                                          settingInputForm?.auto_create_payments
                                        }
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "auto_create_payments",
                                            e?.target?.value
                                          )
                                        }
                                        name="data[Merchant][auto_create_payments]"
                                        className="valid"
                                        id="MerchantAutoCreatePayments"
                                      >
                                        <option value="">Select</option>
                                        {checkNull(
                                          finance_general_details?.yesnoOptions
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.yesnoOptions
                                          ).map((index) => {
                                            return (
                                              <option value={index} key={index}>
                                                {" "}
                                                {
                                                  finance_general_details
                                                    ?.yesnoOptions?.[index]
                                                }{" "}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="auto_create_payments"
                                      />
                                    </div>
                                  </li>
                                  {!isChildAccount(user_details) && (
                                    <>
                                      <li>
                                        <label className="">
                                          Purchase Requisition Auto-Approval
                                          Threshold
                                        </label>
                                        <div className="input-group d-flex align-items-center pt-0">
                                          <span className="dolor-sign">$</span>
                                          <input
                                            {...settingReg(
                                              "purchase_requisition_auto_approval"
                                            )}
                                            value={
                                              settingInputForm?.purchase_requisition_auto_approval
                                            }
                                            onChange={(e) =>
                                              changeSettingInputHandler(
                                                "purchase_requisition_auto_approval",
                                                e?.target?.value
                                              )
                                            }
                                            name="data[Merchant][purchase_requisition_auto_approval]"
                                            className="valid  number"
                                            placeholder="Set Approval Threshold"
                                            maxlength="50"
                                            type="text"
                                            id="MerchantPurchaseRequisitionAutoApproval"
                                          />{" "}
                                          <ErrorContainer
                                            errors={settingErrors}
                                            name="purchase_requisition_auto_approval"
                                          />
                                        </div>
                                      </li>
                                      <li>
                                        <label className="">
                                          Trade Order Auto-Approval Threshold
                                        </label>
                                        <div className="input-group d-flex align-items-center pt-0">
                                          <span className="dolor-sign">$</span>
                                          <input
                                            {...settingReg(
                                              "trade_order_auto_approval"
                                            )}
                                            value={
                                              settingInputForm?.trade_order_auto_approval
                                            }
                                            onChange={(e) =>
                                              changeSettingInputHandler(
                                                "trade_order_auto_approval",
                                                e?.target?.value
                                              )
                                            }
                                            name="data[Merchant][trade_order_auto_approval]"
                                            className="valid  number"
                                            placeholder="Set Approval Threshold"
                                            maxlength="50"
                                            type="text"
                                            id="MerchantTradeOrderAutoApproval"
                                          />{" "}
                                          <ErrorContainer
                                            errors={settingErrors}
                                            name="purchase_requisition_auto_approval"
                                          />
                                        </div>
                                      </li>

                                      <li>
                                        <label className="required">
                                          Default Posting Period Status
                                        </label>
                                        <div className="input-group select-div">
                                          <select
                                            {...settingReg(
                                              "default_posting_period_status"
                                            )}
                                            value={
                                              settingInputForm?.default_posting_period_status
                                            }
                                            onChange={(e) =>
                                              changeSettingInputHandler(
                                                "default_posting_period_status",
                                                e?.target?.value
                                              )
                                            }
                                            name="data[Merchant][default_posting_period_status]"
                                            required="required"
                                            className="valid"
                                            id="MerchantDefaultPostingPeriodStatus"
                                          >
                                            <option value="">Select</option>
                                            {checkNull(
                                              finance_general_details?.openCloseOptions
                                            ) &&
                                              Object.keys(
                                                finance_general_details?.openCloseOptions
                                              ).map((index) => {
                                                return (
                                                  <option
                                                    value={index}
                                                    key={index}
                                                  >
                                                    {" "}
                                                    {
                                                      finance_general_details
                                                        ?.openCloseOptions?.[
                                                        index
                                                      ]
                                                    }{" "}
                                                  </option>
                                                );
                                              })}
                                          </select>{" "}
                                          <ErrorContainer
                                            errors={settingErrors}
                                            name="default_posting_period_status"
                                          />
                                        </div>
                                      </li>
                                    </>
                                  )}

                                  <li>
                                    <label className="required">
                                      Daily Sales Email Preference
                                    </label>
                                    <div className="input-group select-div">
                                      <select
                                        {...settingReg(
                                          "daily_sales_email_preference"
                                        )}
                                        value={
                                          settingInputForm?.daily_sales_email_preference
                                        }
                                        onChange={(e) =>
                                          changeSettingInputHandler(
                                            "daily_sales_email_preference",
                                            e?.target?.value
                                          )
                                        }
                                        name="data[Merchant][daily_sales_email_preference]"
                                        required="required"
                                        className="valid"
                                        id="MerchantDailySalesEmailPreference"
                                      >
                                        <option value="">Select</option>
                                        {checkNull(
                                          finance_general_details?.dailySalesEmailPreference
                                        ) &&
                                          Object.keys(
                                            finance_general_details?.dailySalesEmailPreference
                                          ).map((index) => {
                                            return (
                                              <option value={index} key={index}>
                                                {" "}
                                                {
                                                  finance_general_details
                                                    ?.dailySalesEmailPreference?.[
                                                    index
                                                  ]
                                                }{" "}
                                              </option>
                                            );
                                          })}
                                      </select>{" "}
                                      <ErrorContainer
                                        errors={settingErrors}
                                        name="daily_sales_email_preference"
                                      />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="mCSB_draggerContainer">
                              <div
                                className="mCSB_dragger"
                                oncontextmenu="return false;"
                              >
                                <div className="mCSB_dragger_bar"></div>
                              </div>
                              <div className="mCSB_draggerRail"></div>
                            </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 timeSetting operatingDaysMs">
                <div className="shadowclass mt-0">
                  <h4 className="event-alert">Operating Days &amp; Hours</h4>
                  <div className="inner-space screen-scroll mCS_destroyed">
                    <table className="checklist-table remove-space aviTable">
                      <thead>
                        <tr>
                          <th width="15">&nbsp;</th>
                          <th className="col-2">Day</th>
                          <th className="col-5">From</th>
                          <th className="col-5">To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {checkNull(finance_general_details?.dayNames) &&
                          Object.keys(finance_general_details?.dayNames).map(
                            (index, key) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        className="avail_checkbox"
                                        id={`checkbox_index_${key}`}
                                        checked={
                                          scheduleDayForm[index].is_checked
                                        }
                                        onClick={() => {
                                          changeScheduleDayHandler(
                                            index,
                                            "is_checked",
                                            !scheduleDayForm[index].is_checked
                                          );
                                        }}
                                      />
                                      <label
                                        for={`checkbox_index_${key}`}
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    {" "}
                                    {
                                      finance_general_details?.dayNames?.[index]
                                    }{" "}
                                  </td>
                                  <td>
                                    <div className="timePicker">
                                      <TimePicker
                                        timeMode="12"
                                        minuteStep={30}
                                        time={scheduleDayForm[index].start_time}
                                        onTimeChange={(options) => {
                                          const { hour, minute, meridiem } =
                                            options;
                                          changeScheduleDayHandler(
                                            index,
                                            "start_time",
                                            `${hour}:${minute} ${meridiem}`
                                          );
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="timePicker">
                                      <TimePicker
                                        timeMode="12"
                                        minuteStep={30}
                                        time={scheduleDayForm[index].end_time}
                                        onTimeChange={(options) => {
                                          const { hour, minute, meridiem } =
                                            options;
                                          changeScheduleDayHandler(
                                            index,
                                            "end_time",
                                            `${hour}:${minute} ${meridiem}`
                                          );
                                        }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <button
              type={"submit"}
              ref={settingFormBtn}
              style={{ display: "none" }}
            ></button>
          </div>
        </form>
      </div>

      <div className="accordion" id="accordionPanelsStayOpenExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseOne"
              aria-expanded="true"
              aria-controls="panelsStayOpen-collapseOne"
            >
              <div className="col d-flex align-items-center">
                <h4 className="event-alert p-0 mb-0">Accounting Tax Years</h4>
              </div>{" "}
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="panelsStayOpen-headingOne"
          >
            <div className="">
              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass mt-0">
                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th width="80">
                              <a href="#_" className="">
                                Tax Year
                              </a>
                            </th>
                            <th>Accounting Period Setting</th>
                            <th>Sub-Periods</th>
                            <th>Period Start</th>
                            <th>Period End</th>
                            <th>Documents</th>
                            <th width="12%" className="hide-small"></th>
                            <th className="action-td">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {finance_general_details?.accountingPeriods &&
                            finance_general_details?.accountingPeriods.length >
                              0 &&
                            finance_general_details?.accountingPeriods.map(
                              (accountingPeriod) => {
                                return (
                                  <tr>
                                    <td>{accountingPeriod?.tax_year ?? ""}</td>
                                    <td>
                                      {accountingPeriod?.account_period_setting
                                        ?.name ?? ""}
                                    </td>
                                    <td>
                                      {accountingPeriod?.sub_period
                                        ? capitalizeFirstLetter(
                                            accountingPeriod?.sub_period
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {checkNull(
                                        accountingPeriod?.start_date,
                                        false
                                      )
                                        ? parseStringToDate(
                                            accountingPeriod?.start_date,
                                            "yyyy-MM-DD",
                                            "MMMM DD, yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {checkNull(
                                        accountingPeriod?.end_date,
                                        false
                                      )
                                        ? parseStringToDate(
                                            accountingPeriod?.end_date,
                                            "yyyy-MM-DD",
                                            "MMMM DD, yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td class="attachmentTd">
                                      <div class="attach-row">
                                        {accountingPeriod?.accounting_period_document &&
                                          accountingPeriod
                                            ?.accounting_period_document
                                            .length > 0 &&
                                          accountingPeriod?.accounting_period_document.map(
                                            (document) => {
                                              return (
                                                <>
                                                  <div class="attachments">
                                                    <a
                                                      role="button"
                                                      onClick={() =>
                                                        downloadFileFromUrl(
                                                          document?.document_url,
                                                          getFileNameFromUrl(
                                                            document?.document_url
                                                          )
                                                        )
                                                      }
                                                    >
                                                      <i class="icon"> </i>{" "}
                                                      {checkNull(
                                                        document?.document_url,
                                                        false
                                                      )
                                                        ? getFileNameFromUrl(
                                                            document?.document_url
                                                          )
                                                        : ""}
                                                    </a>
                                                  </div>
                                                  {!isChildAccount(
                                                    user_details
                                                  ) && (
                                                    <div
                                                      class="circle_icon red"
                                                      onClick={() => {
                                                        setAccDocumentId(
                                                          document?.id ?? null
                                                        );
                                                        closeDeleteDocumentModal(
                                                          true
                                                        );
                                                      }}
                                                    >
                                                      <i
                                                        class="iconSprites delete-icon delAccDoc"
                                                        val="8"
                                                      ></i>
                                                    </div>
                                                  )}
                                                </>
                                              );
                                            }
                                          )}
                                      </div>
                                    </td>
                                    <td>
                                      <a
                                        className="btn bordered-btn add-plus addDocAccounting"
                                        count="325"
                                        onClick={() => {
                                          setAccPeriodId(
                                            accountingPeriod?.id ?? null
                                          );
                                          closeDocumentModal(true);
                                        }}
                                      >
                                        <i className="i-icon"></i> Add Document
                                      </a>
                                    </td>
                                    <td className="action-td">
                                      {checkNull(
                                        accountingPeriod?.start_date,
                                        false
                                      ) &&
                                        isPastFromToday(
                                          accountingPeriod?.start_date
                                        ) &&
                                        !isChildAccount(user_details) && (
                                          <a
                                            role="button"
                                            class="circle_icon editApFinance"
                                            onClick={() =>
                                              editAccountingHandler(
                                                accountingPeriod
                                              )
                                            }
                                          >
                                            <i class="iconSprites edit-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Edit{" "}
                                              </div>
                                            </i>
                                          </a>
                                        )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  <div className="my-3">
                          {!isChildAccount(user_details) && (
                                <button
                                  className="btn green-btn-revert add-plus addAp mx-0"
                                  type="button"
                                  onClick={() => closeAccModal(true)}
                                >
                                  <i className="i-icon"> </i> Add Tax Year{" "}
                                </button>
                          )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwo"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTwo"
            >
              <h4 className="event-alert p-0 mb-0">Posting Periods</h4>
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingTwo"
          >
            <div className="">
              <div className="row mx-0">
                <div className="container px-0 d-flex">
                  <div className="shadowclass mt-0">
                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th width="160">Status</th>
                            <th width="135">Tax Year</th>
                            <th>Period Start</th>
                            <th>Period End</th>
                            <th>Date Closed</th>
                            <th>Closed By</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {finance_general_details?.posting_period &&
                            finance_general_details?.posting_period.length >
                              0 &&
                            finance_general_details?.posting_period.map(
                              (period) => {
                                return (
                                  <tr>
                                    <td>
                                      <span
                                        className={
                                          period?.status_id == 56
                                            ? "green_tag"
                                            : "grey_tag"
                                        }
                                      >
                                        {finance_general_details
                                          ?.posting_period_status?.[
                                          period?.status_id
                                        ] ?? ""}
                                      </span>
                                    </td>
                                    <td class="">{period?.tax_year ?? ""}</td>
                                    <td>
                                      {checkNull(period?.period_start, false)
                                        ? parseStringToDate(
                                            period?.period_start,
                                            "yyyy-MM-DD",
                                            "MMMM DD, yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {checkNull(period?.period_start, false)
                                        ? parseStringToDate(
                                            period?.period_end,
                                            "yyyy-MM-DD",
                                            "MMMM DD, yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {checkNull(period?.period_start, false)
                                        ? parseStringToDate(
                                            period?.date_closed,
                                            "yyyy-MM-DD",
                                            "MMMM DD, yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {checkNull(period?.closed_by, false)
                                        ? `${period?.user?.first_name} ${period?.user?.last_name}`
                                        : ""}
                                    </td>
                                    <td className="align-right">
                                      {getAccPeriodStatusBtn(period)}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="container px-0 d-flex col-12">
          <div className="btns col-4 d-flex justify-content-end py-4 col-12">
            <LoadingBtn
              is_loading={is_save_general_details_loading}
              type="button"
              onClick={() =>
                checkNull(settingFormBtn?.current, false)
                  ? settingFormBtn?.current.click()
                  : null
              }
            >
              Save
            </LoadingBtn>
            <button id="cancel" type="button">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`${
          accInputForm?.ap_id !== "" ? "Edit" : "Add"
        } Accounting Period`}
        open={accountingModal}
        closeModal={closeAccModal}
        submitModal={accountingSubmit(submitAccountingForm)}
        is_loading={is_modal_loading}
      >
        <form>
          <input
            type="hidden"
            name="is_first_period"
            {...register("is_first_period")}
            value={accInputForm?.is_first_period}
          />
          <input
            type="hidden"
            name="ap_id"
            {...register("ap_id")}
            value={accInputForm?.ap_id}
          />
          {console.log("accErrors", accErrors)}
          <div className="form-list">
            <ul className="px-0">
              <li>
                <label className="required"> Tax Year </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("tax_year")}
                    name="tax_year"
                    className="required changing tax_year_class"
                    onChange={(event) =>
                      changeAccInputHandler("tax_year", event?.target?.value)
                    }
                    value={accInputForm?.tax_year}
                  >
                    <option value=""> Select Tax Year </option>
                    {finance_general_details?.tenYearsBetween &&
                      finance_general_details?.tenYearsBetween !== null &&
                      accInputForm?.ap_id == "" &&
                      Object.keys(finance_general_details?.tenYearsBetween).map(
                        (index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {
                                finance_general_details?.tenYearsBetween?.[
                                  index
                                ]
                              }{" "}
                            </option>
                          );
                        }
                      )}
                    {accInputForm?.ap_id !== "" && (
                      <option value={accInputForm?.tax_year}>
                        {accInputForm?.tax_year}
                      </option>
                    )}
                  </select>
                  <ErrorContainer errors={accErrors} name="tax_year" />
                </div>
              </li>

              <li>
                <label className="required"> Account Period Setting </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("account_period_setting_id")}
                    name="account_period_setting_id"
                    className="required changing tax_year_class"
                    onChange={(event) =>
                      changeAccInputHandler(
                        "account_period_setting_id",
                        event?.target?.value
                      )
                    }
                    value={accInputForm?.account_period_setting_id}
                  >
                    <option value=""> Select </option>
                    {finance_general_details?.accountPeriodSettings &&
                      finance_general_details?.accountPeriodSettings !== null &&
                      finance_general_details?.accountPeriodSettings.map(
                        (psetting) => {
                          return (
                            <option value={psetting?.id} key={psetting?.id}>
                              {" "}
                              {psetting?.name}{" "}
                            </option>
                          );
                        }
                      )}
                  </select>
                  <ErrorContainer
                    errors={accErrors}
                    name="account_period_setting_id"
                  />
                </div>
              </li>

              <li>
                <label className="required"> Sub Period </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("sub_period")}
                    name="sub_period"
                    className="required changing tax_year_class"
                    onChange={(event) =>
                      changeAccInputHandler("sub_period", event?.target?.value)
                    }
                    value={accInputForm?.sub_period}
                  >
                    <option value=""> Select </option>
                    {finance_general_details?.sub_period &&
                      finance_general_details?.sub_period !== null > 0 &&
                      Object.keys(finance_general_details?.sub_period).map(
                        (index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {
                                finance_general_details?.sub_period?.[index]
                              }{" "}
                            </option>
                          );
                        }
                      )}
                  </select>
                  <ErrorContainer errors={accErrors} name="sub_period" />
                </div>
              </li>

              {accInputForm?.account_period_setting_id &&
                accInputForm?.account_period_setting_id !== "" &&
                [1, 2, 3].indexOf(
                  parseInt(accInputForm?.account_period_setting_id)
                ) != -1 && (
                  <li class="settingsLi">
                    <label for="AccountingPeriodDayOfWeek" class="required">
                      Setting Type
                    </label>
                    <div class="input-wrap select-div">
                      <select
                        {...register("day_of_week")}
                        name="day_of_week"
                        class="required"
                        id="AccountingPeriodDayOfWeek"
                        onChange={(event) =>
                          changeAccInputHandler(
                            "day_of_week",
                            event?.target?.value
                          )
                        }
                        value={accInputForm?.day_of_week}
                      >
                        <option value="">Select Setting Type</option>
                        {finance_general_details?.settingTypes &&
                          finance_general_details?.settingTypes !== null &&
                          Object.keys(
                            finance_general_details?.settingTypes
                          ).map((index) => {
                            return (
                              <option value={index} key={index}>
                                {" "}
                                {
                                  finance_general_details?.settingTypes?.[index]
                                }{" "}
                              </option>
                            );
                          })}
                      </select>
                      <ErrorContainer errors={accErrors} name="day_of_week" />
                    </div>
                  </li>
                )}

              <li>
                <label className="required"> Period Start </label>
                <div className="input-wrap">
                  {/* <input
                    type="text"
                    name="start_date"
                    className="datepicker"
                  ></input> */}
                  <DatePicker
                    {...register("start_date")}
                    name="start_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) => changeAccInputHandler("start_date", val)}
                    selected={accInputForm?.start_date}
                  />
                  {/* <span class="add-on">
                    <i class="fa fa-calendar"></i>
                  </span> */}
                </div>
                <ErrorContainer errors={accErrors} name="start_date" />
              </li>

              <li>
                <label className="required"> Period End</label>
                <div className="input-wrap">
                  {/* <input
                    type="text"
                    name="end_date"
                    className="datepicker"
                  ></input> */}
                  <DatePicker
                    {...register("end_date")}
                    name="end_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) => changeAccInputHandler("end_date", val)}
                    selected={accInputForm?.end_date}
                    readonly
                    disabled
                  />
                  {/* <span class="add-on">
                    <i class="fa fa-calendar"></i>
                  </span> */}
                </div>
                <ErrorContainer errors={accErrors} name="end_date" />
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`Add Document`}
        open={documentModal}
        closeModal={closeDocumentModal}
        submitModal={submitDocument}
        is_loading={is_modal_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form d-flex">
            {selectedDocFile !== null && (
              <li className="text-center mx-4 my-3">
                <img
                  style={{ maxWidth: "200px", maxHeight: "200px" }}
                  src={URL.createObjectURL(selectedDocFile)}
                />
              </li>
            )}
            <li>
              <label for="AccountingPeriodDocumentDocumentUrl" class="required">
                Upload Document
              </label>{" "}
              <div class="input-wrap browse-sec">
                <input
                  type="file"
                  class="required"
                  id="AccountingPeriodDocumentDocumentUrl"
                  onChange={onDocumentFileChangeEvent}
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
      <ConfirmModel
        title="Delete Document"
        text="are you sure?"
        open={deleteDocumentModal}
        closeModal={closeDeleteDocumentModal}
        submitModal={submitDeleteDocumentHandler}
        is_loading={false}
      />
      <ConfirmModel
        title="Update Status"
        text="Are you sure you want to update the status?"
        open={accPostingPeriodModal}
        closeModal={closeAccPostingPeriodModal}
        submitModal={submitAccPostingPeriodHandler}
        is_loading={false}
      />
    </div>
  );
};
export default Settings;
